import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";
import {BulkQnaModelDisplayName} from './../types';

export const useSaveBulkQnaMutation = () => {
  return useMutation<
    { id: number },
    AxiosError<any>,
    {
      file: File;
      name: string;
      modelType: string;
      openaiModelPreference?: BulkQnaModelDisplayName
    }
  >(
    ({ file, name, modelType, openaiModelPreference }) => {
      const body = new FormData();
      body.append("file", file);
      body.append("name", name);
      body.append("model", modelType);

      if(openaiModelPreference){
        body.append('modelPreference', openaiModelPreference);
      }
      
      return axiosClient
        .post(`/qna/bulkqna`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60 * 1000, // 1min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
